
<div class="text-center mt-4">

  <a  [routerLink]="['/student/dashboard',learner.server_user_id]" class="btn btn-primary my-1">
     <i class="fa fa-trophy"></i> Gifts Won <span class="badge badge-primary"> {{maskedGift.giftcount}} </span>
  </a>

<div class="card text-center">
  <div class="card-header text-center"><h4 >You are awesome </h4> </div>
    <div class="card-body" id="gifting-info">

     <a  href="#" *ngIf="!maskedGift.isGiftReady"
        (click) ="onClickGiftInfo(); $event.stopPropagation();$event.preventDefault()" >
        <img [src]="imageSource" alt="Image Source" width="75%" >
    </a>

    <a  href="#"  *ngIf="maskedGift.isGiftReady && !isRedeeming"
        (click) ="onClickRedeemGift();$event.stopPropagation();$event.preventDefault()">
        <img  [src]="imageSource" alt="Image Source" width="75%">
  </a>

      <span *ngIf="isRedeeming">
        <h2 class="text-center">{{isRedeemingMessage}}</h2>
      </span>

    </div>
    </div>
  </div>

